/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    TraceNode,
    TraceNodeFromJSON,
    TraceNodeFromJSONTyped,
    TraceNodeToJSON,
} from './';

/**
 * 
 * @export
 * @interface FilesystemTraceEndpointResponse
 */
export interface FilesystemTraceEndpointResponse {
    /**
     * 
     * @type {TraceNode}
     * @memberof FilesystemTraceEndpointResponse
     */
    root: TraceNode;
    /**
     * 
     * @type {number}
     * @memberof FilesystemTraceEndpointResponse
     */
    diskDRead: number;
    /**
     * 
     * @type {number}
     * @memberof FilesystemTraceEndpointResponse
     */
    diskDWrite: number;
    /**
     * 
     * @type {boolean}
     * @memberof FilesystemTraceEndpointResponse
     */
    isFlat: boolean;
}

export function FilesystemTraceEndpointResponseFromJSON(json: any): FilesystemTraceEndpointResponse {
    return FilesystemTraceEndpointResponseFromJSONTyped(json, false);
}

export function FilesystemTraceEndpointResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FilesystemTraceEndpointResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'root': TraceNodeFromJSON(json['root']),
        'diskDRead': json['disk_d_read'],
        'diskDWrite': json['disk_d_write'],
        'isFlat': json['is_flat'],
    };
}

export function FilesystemTraceEndpointResponseToJSON(value?: FilesystemTraceEndpointResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'root': TraceNodeToJSON(value.root),
        'disk_d_read': value.diskDRead,
        'disk_d_write': value.diskDWrite,
        'is_flat': value.isFlat,
    };
}


